import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import styles from './pdfPage.scss';

@CSSModules(styles, {allowMultiple: true})
export default class PdfPage extends React.Component {

  static propTypes = {
    page: PropTypes.object.isRequired,
    pageDoneCallback: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      isLoaded: false
    };
  }

  componentDidMount() {
    const canvas = ReactDOM.findDOMNode(this);
    const width = canvas.clientWidth;

    const page = this.props.page;
    const scale = (width * (window.devicePixelRatio || 1)) / page.getViewport(1).width;
    const viewport = page.getViewport(scale);

    // Prepare canvas using PDF page dimensions
    const context = canvas.getContext('2d');
    canvas.height = viewport.height;
    canvas.width = viewport.width;

    // Render PDF page into canvas context
    const renderContext = {
      canvasContext: context,
      viewport: viewport
    };

    const renderTask = page.render(renderContext);
    renderTask.then(
      () => {
        this.handlePageLoaded();
      }
    );
  }

  handlePageLoaded(): void {
    this.setState(() => {
      return {isLoaded: true};
    });
    this.props.pageDoneCallback();
  }

  render() {
    return (
      <canvas ref="pdfPage" styleName="pdf-page" />
    );
  }
}



// WEBPACK FOOTER //
// ./src/pdf/PdfPage.js